<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
                  v-model="searchForm.authorize_no"
                  placeholder="授权单号"
                  style="width: 100px;"
          />
        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.freezing_state"
                  placeholder="状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.velue"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
        >
        <el-date-picker
                v-model="dateRange"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"    width="150">

        </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column label="序号" type="index" align="center" show-overflow-tooltip width="50px">
      </el-table-column>

      <el-table-column
        label="授权单号"
      >
        <template slot-scope="scope">
          {{scope.row.authorize_no}}
        </template>
      </el-table-column>
      <el-table-column
        label="冻结金额"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.freezing_amount}}
        </template>
      </el-table-column>
      <el-table-column
        label="冻结状态"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.freezing_state}}
        </template>
      </el-table-column>

      <el-table-column
              label="支付金额"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.payment_amount}}
        </template>
      </el-table-column>
      <el-table-column
              label="消费单号"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.consumption_no}}
        </template>
      </el-table-column>
      <el-table-column
              label="冻结时间"
              width="150"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.freezing_times}}
        </template>
      </el-table-column>
      <el-table-column
              label="备注"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.remarks}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"    @click="openViewForm(scope.row)">备注</el-button>
          <el-button type="primary" plain  size="mini"   :disabled="scope.row.freezing_state == '冻结成功' ? false:true"  @click="del(scope.row.id)">退押金</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <view-form
            :agent="agent"
            v-model="viewFormVisible"
            @submit="getTableData"
    />
  </d2-container>
</template>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
    import viewForm from "./viewForm"
export default {
  name: "PosterPage",
  components: {viewForm},
  data() {
    return {
      searchForm: {
      },
      loading: false,
        agent: {},
        editFormVisible: false,
        viewFormVisible: false,
      tableData: [],
        dateRange: [],
        pickerOptions:{},
      multipleSelection: [],
        typeOptions: [
            {
                value: "冻结中",
                label: "冻结中"
            },
            {
                value: "冻结成功",
                label: "冻结成功"
            },
            {
                value: "冻结失败",
                label: "冻结失败"
            },
            {
                value: "已解冻",
                label: "已解冻"
            }
        ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      }
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
      dateConversion(value) {
          if (value != null && value != "") {
              var d = new Date(value);
              //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
              var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
              console.info("===========date=========" + date);
              return date;
          }else{
              return "";
          }
      },
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
          start_time:this.dateConversion(this.dateRange[0]),
          end_time:this.dateConversion(this.dateRange[1]),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getDepositPagedlist(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    openEditForm(agent) {
      this.agent = agent;
      this.editFormVisible = true;
        this.viewFormVisible = false;
    },
      openViewForm(agent) {
          this.agent = agent;
          this.editFormVisible = false;
          this.viewFormVisible = true;
      },
    del(id) {
      this.$confirm("确认退押金？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消"
      }).then(() => {
          agentService.delDeposit({id:id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
